var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportListView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 1446,
    height: 31,
    "aria-labelledby": titleId,
    viewBox: "0 0 1446 31",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loading-aria"
  }, "Loading...") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loading-aria"
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    clipPath: "url(#clip-path)",
    style: {
      fill: "url(\"#fill\")"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 0,
    rx: 0,
    ry: 0,
    width: 119,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 25,
    rx: 0,
    ry: 0,
    width: 89,
    height: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 15,
    r: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 10,
    rx: 5,
    ry: 5,
    width: 50,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 0,
    rx: 0,
    ry: 0,
    width: 30,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 16,
    rx: 0,
    ry: 0,
    width: 70,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570,
    y: 3,
    rx: 13,
    ry: 13,
    width: 75,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 3,
    rx: 13,
    ry: 13,
    width: 95,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 750,
    y: 3,
    rx: 13,
    ry: 13,
    width: 45,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 3,
    rx: 13,
    ry: 13,
    width: 35,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 3,
    rx: 13,
    ry: 13,
    width: 55,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 3,
    rx: 13,
    ry: 13,
    width: 45,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1070,
    y: 3,
    rx: 13,
    ry: 13,
    width: 85,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 3,
    rx: 13,
    ry: 13,
    width: 115,
    height: 27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1376,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1411,
    cy: 16,
    r: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.599964,
    stopColor: "#f3f3f3",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-2; -2; 1",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 1.59996,
    stopColor: "#96abba",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-1; -1; 2",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 2.59996,
    stopColor: "#f3f3f3",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0; 0; 3",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportListView);
export default __webpack_public_path__ + "static/media/report_list_view.702e674debf50f00071177a7cf774c24.svg";
export { ForwardRef as ReactComponent };